// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-slider-container .gyramais-slider .ant-slider-rail {
  height: 0.5rem;
  border-radius: 1rem;
  transform: translateY(-0.14rem);
}
.gyramais-slider-container .gyramais-slider .ant-slider-track {
  background-color: var(--primary-button-color);
  height: 0.5rem;
  border-radius: 1rem;
  transform: translateY(-0.14rem);
}
.gyramais-slider-container .gyramais-slider .ant-slider-handle {
  transform: scale(1.2) translateX(-0.38rem) !important;
  border: solid 1px #c9d3cc;
}
.gyramais-slider-container .gyramais-slider .ant-slider-step .ant-slider-dot {
  border-color: var(--primary-button-color);
}
.gyramais-slider-container .gyramais-slider .ant-slider-mark .ant-slider-mark-text {
  color: #c9d3cc;
  font-weight: 400;
  transition: 0.3s;
}
.gyramais-slider-container .gyramais-slider .ant-slider-mark .ant-slider-mark-text-active {
  color: #000000d9;
  margin-top: 0.4rem;
}
.gyramais-slider-container .gyramais-slider:hover .ant-slider-rail {
  background-color: #f5f5f5;
}
.gyramais-slider-container .gyramais-slider.warning-gyramais-slider .ant-slider-track {
  background-color: var(--warning-color);
}
.gyramais-slider-container .gyramais-slider.danger-gyramais-slider .ant-slider-track {
  background-color: var(--danger-color);
}
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled) .ant-slider-handle:hover,
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled) .ant-slider-handle:focus {
  transform: scale(1.4) translateX(-0.3rem) !important;
  border: solid 1px #c9d3cc;
  box-shadow: none;
}
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled):hover .ant-slider-handle {
  transform: scale(1.4) translateX(-0.3rem) !important;
  border: solid 1px #c9d3cc;
}
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled):hover .ant-slider-rail {
  background-color: #e1e1e1;
}
.gyramais-slider-container .gyramais-slider-value {
  font-weight: 500;
}
.gyramais-slider-container .gyramais-slider-range-value {
  transform: translateY(-0.5rem);
}
.gyramais-slider-container .gyramais-slider-value-input {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  min-height: auto;
  width: 8rem;
  height: 1.6rem;
}
.gyramais-slider-container .gyramais-slider-value-input .ant-input-number-handler-wrap {
  display: none;
}
.gyramais-slider-container .gyramais-slider-value-input.ant-input-number-focused {
  box-shadow: none;
  border-bottom-color: var(--primary-button-color);
}
.gyramais-slider-container .gyramais-slider-value-input input {
  padding: 0;
  font-weight: 500;
  font-size: 0.875rem;
  text-align: center;
}
.gyramais-slider-container .gyramais-slider-value-input.ant-input-number-disabled {
  background-color: transparent;
}
.gyramais-slider-container .gyramais-slider-value-input.ant-input-number-disabled:hover {
  border-bottom-color: #d9d9d9;
}
.gyramais-slider-skeleton {
  width: 100%;
  border-radius: 0.8rem !important;
}
.gyramais-slider-skeleton span {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/sdk/Slider/styles.less"],"names":[],"mappings":"AAAA;EAGM,cAAA;EACA,mBAAA;EAEA,+BAAA;AAFN;AAJA;EAUM,6CAAA;EACA,cAAA;EACA,mBAAA;EAEA,+BAAA;AAJN;AAVA;EAkBM,qDAAA;EAEA,yBAAA;AANN;AAdA;EAyBQ,yCAAA;AARR;AAjBA;EA+BQ,cAAA;EACA,gBAAA;EACA,gBAAA;AAXR;AAtBA;EAqCQ,gBAAA;EACA,kBAAA;AAZR;AAgBI;EAEI,yBAAA;AAfR;AAmBI;EAEI,sCAAA;AAlBR;AAsBI;EAEI,qCAAA;AArBR;AA2BQ;;EAEE,oDAAA;EAEA,yBAAA;EACA,gBAAA;AA1BV;AA8BM;EAEI,oDAAA;EAEA,yBAAA;AA9BV;AA0BM;EAQI,yBAAA;AA/BV;AAhDA;EAsFI,gBAAA;AAnCJ;AAnDA;EAyFI,8BAAA;AAnCJ;AAtDA;EA6FI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,WAAA;EACA,cAAA;AArCJ;AA/DA;EAuGM,aAAA;AArCN;AAwCI;EACE,gBAAA;EACA,gDAAA;AAtCN;AAtEA;EAgHM,UAAA;EAEA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAxCN;AA2CI;EACE,6BAAA;AAzCN;AA2CM;EACE,4BAAA;AAzCR;AA+CA;EACE,WAAA;EACA,gCAAA;AA7CF;AA2CA;EAKI,sBAAA;AA7CJ","sourcesContent":[".gyramais-slider-container {\n  .gyramais-slider {\n    .ant-slider-rail {\n      height: 0.5rem;\n      border-radius: 1rem;\n\n      transform: translateY(-0.14rem);\n    }\n\n    .ant-slider-track {\n      background-color: var(--primary-button-color);\n      height: 0.5rem;\n      border-radius: 1rem;\n\n      transform: translateY(-0.14rem);\n    }\n\n    .ant-slider-handle {\n      transform: scale(1.2) translateX(-0.38rem) !important;\n\n      border: solid 1px #c9d3cc;\n    }\n\n    .ant-slider-step {\n      .ant-slider-dot {\n        border-color: var(--primary-button-color);\n      }\n    }\n\n    .ant-slider-mark {\n      .ant-slider-mark-text {\n        color: #c9d3cc;\n        font-weight: 400;\n        transition: 0.3s;\n      }\n\n      .ant-slider-mark-text-active {\n        color: #000000d9;\n        margin-top: 0.4rem;\n      }\n    }\n\n    &:hover {\n      .ant-slider-rail {\n        background-color: #f5f5f5;\n      }\n    }\n\n    &.warning-gyramais-slider {\n      .ant-slider-track {\n        background-color: var(--warning-color);\n      }\n    }\n\n    &.danger-gyramais-slider {\n      .ant-slider-track {\n        background-color: var(--danger-color);\n      }\n    }\n\n    &:not(.ant-slider-disabled) {\n      .ant-slider-handle {\n        &:hover,\n        &:focus {\n          transform: scale(1.4) translateX(-0.3rem) !important;\n\n          border: solid 1px #c9d3cc;\n          box-shadow: none;\n        }\n      }\n\n      &:hover {\n        .ant-slider-handle {\n          transform: scale(1.4) translateX(-0.3rem) !important;\n\n          border: solid 1px #c9d3cc;\n        }\n\n        .ant-slider-rail {\n          background-color: #e1e1e1;\n        }\n      }\n    }\n  }\n\n  .gyramais-slider-value {\n    font-weight: 500;\n  }\n  .gyramais-slider-range-value {\n    transform: translateY(-0.5rem);\n  }\n\n  .gyramais-slider-value-input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-radius: 0;\n\n    min-height: auto;\n    width: 8rem;\n    height: 1.6rem;\n\n    .ant-input-number-handler-wrap {\n      display: none;\n    }\n\n    &.ant-input-number-focused {\n      box-shadow: none;\n      border-bottom-color: var(--primary-button-color);\n    }\n\n    input {\n      padding: 0;\n\n      font-weight: 500;\n      font-size: 0.875rem;\n      text-align: center;\n    }\n\n    &.ant-input-number-disabled {\n      background-color: transparent;\n\n      &:hover {\n        border-bottom-color: #d9d9d9;\n      }\n    }\n  }\n}\n\n.gyramais-slider-skeleton {\n  width: 100%;\n  border-radius: 0.8rem !important;\n\n  span {\n    width: 100% !important;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
